// extracted by mini-css-extract-plugin
export default {"root":"Link__root--uLr53","disabledUnderline":"Link__disabledUnderline--CEJtg","grey":"Link__grey--TeAyo","disabled":"Link__disabled--llCEy"};